import BaseModal from "../BaseModal/BaseModal";
import React, {useEffect} from "react";
import {CURRENCY} from "../../settings/settings";
import {CardElement, Elements, PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import FormButton from "../../components/Form/Button/FormButton";
import getStripePromise from "../../API/ApiEndPoints/loadStripe";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";
import {toast} from "react-toastify";
import {useSession} from "../../redux/Reducers/AuthReducer";
import {useNavigate} from "react-router-dom";


function BuyCard({className, selectedPackage, setIsOpen, client_secret, ...props}) {
    const [error, setError] = React.useState(null);
    const elements = useElements();
    const stripe = useStripe();
    const [isLoading, setIsLoading] = React.useState(false);
    const {session, authActions} = useSession();
    const navigation = useNavigate();
    const handleChange = (event) => {
        if (event.error) {
            setError(event.error.message);
        } else {
            setError(null);
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        const {error: submitError} = await elements.submit();
        if (submitError) {
            // Show error to your customer
            setError(submitError.message);
            return;
        }

        setIsLoading(true)


        const {error} = await stripe.confirmPayment({
            elements: elements,
            clientSecret: client_secret,
            confirmParams: {
                return_url: `${window.location.origin}/payment-success`
            }
        });
        setIsLoading(false)
        if (error) {
            setError(error.message);
            setIsLoading(false)
        } else {


        }

    }
    return (<form onSubmit={handleSubmit} className={"flex flex-col  gap-[20px] py-[30px] justify-center items-center"}>
        <img src={"/logo.png"} className={"w-[200px]"} alt={"logo"}/>

        <p>
            <span className={"font-bold"}>{selectedPackage?.name} - {selectedPackage?.price}{CURRENCY}{" "}</span>
            will be charged from your card
        </p>
        <div className={"w-full flex flex-col gap-2"}>
            <PaymentElement id="card-element" className={""} onChange={handleChange}/>
            {error && <ul className={"px-6 list-disc text-red-500"}>
                <li>
                    {error}
                </li>
            </ul>}
        </div>
        <FormButton
            loading={isLoading}
            showLoadingOnLeft={true}
            disabled={!stripe || !elements}
            type={"submit"}
        >
            Pay {selectedPackage?.price}{CURRENCY}
        </FormButton>
    </form>)
}


export default function BuyPackageModal({className, selectedPackage, isOpen, setOpen, ...props}) {
    const stripePromise = getStripePromise()
    const [client_secret, setClientSecret] = React.useState(null)

    const options = {
        // passing the client secret obtained from the server
        appearance: {
            theme: 'stripe',
        },
        clientSecret: client_secret

    };


    useEffect(() => {
        if (!selectedPackage?.id) return;
        if (!isOpen) return;
        setClientSecret(null)
        axiosInstance.post(URLS.CreatePaymentIntent, {
            package_id: selectedPackage?.id,
            referral_code: props?.referral_code
        }).then(respose => {
            setClientSecret(respose.data.client_secret)
        }).catch(error => {
            toast.error(
                error?.response?.data?.detail || "Error creating payment intent"
                , {
                    toastId: "error-creating-payment-intent"
                })
            setOpen(false)
        })
    }, [isOpen])


    return (

        <BaseModal innerClassName={"md:w-[600px]"} isBoxOpen={isOpen} autoClose={false} defaultHeader={true}
                   title={"Add Card Your information"}
                   setIsBoxOpen={setOpen}>

            {

                client_secret ? <Elements stripe={stripePromise}

                                          options={options}

                >
                    <BuyCard selectedPackage={selectedPackage}
                             client_secret={client_secret}
                             setIsOpen={setOpen}/>
                </Elements> : <div className={"h-[200px] text-center flex flex-col justify-center items-center"}>
                    <p>
                        Loading...
                    </p>

                </div>

            }

        </BaseModal>


    )
}